import { createFileRoute } from '@tanstack/react-router';
import { ConnectedAccountsTab } from '@/features/account-settings/tabs/connected-accounts';

export const Route = createFileRoute('/_authenticated/account-settings/connected-accounts')({
    head: () => ({ meta: [{ title: 'Connected Accounts | promote.fun' }] }),
    component: ConnectedAccountsTab,
});
